import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { backArrow } from '../../../../assets/images';
import { dsButtonPrimary, joinButtonClasses } from '../../../../utils/buttonStyles';

const MFALogin = ({requestAuth}) => {
  const history = useHistory()
  let [code, setCode] = useState('')

  return (
    <div className='my-4'>
      <img title='Login' src={backArrow} onClick={() => history.push('/login')} className='mb-3.5 cursor-pointer'/>
      <h1 className='font-fig-extrabold text-xl font-medium leading-8 text-gray-900 mb-0'>Multi-factor Authentication</h1>
      <p className='text-base text-gray-600 mt-2 mr-20 mb-0 w-96'>
        Enter an MFA code to login
      </p>
      <span className='mb-2 mt-10 text-gray-500 text-sm font-semibold tracking-widest block'>MFA Code:</span>
      <input
        id='otp'
        type='text'
        name='username'
        placeholder='CODE'
        value={code}
        onChange={(e) => {setCode(e.target.value)}}
        className={
          'text-base caret-blue-600 text-gray-700 placeholder-gray-300 leading-4 font-semibold pl-4 border border-gray-200 rounded-md w-96 h-14 bg-gray-100 focus:bg-gray-100 focus:ring-0  focus:outline-none focus:border-gray-400'
        }
      />
      <button
        onClick={() => requestAuth(code)}
        className={joinButtonClasses(dsButtonPrimary, 'mt-8 h-12 w-96')}
      >
        Submit
      </button>
    </div>
  )

}

export default MFALogin;
